import { Component, Input } from '@angular/core';
import { MdSnackBar } from '@angular/material';
import { Product } from '../../models/Product';
import { Version } from '../../models/Version';
import { SoftwareService } from '../../shared/software.service';
import { AuthService } from '../../shared/auth.service';
import { Router } from '@angular/router';

@Component({
    selector: 'versions',
    providers: [AuthService], 
    templateUrl: './versions.component.html',
    styleUrls: ['./versions.component.css']
})
export class VersionsComponent {
    releaseStatus = [
        ['Prototype', 0],
        ['Alpha', 1],
        ['Beta', 2],
        ['Internal', 3],
        ['Dealership', 4],
        ['Production', 5],
        ['Obsolete', 6]
        ];

    versions: Version[] = [];

    busy: boolean = false;

    constructor(private softwareService: SoftwareService, public auth: AuthService, public snackBar: MdSnackBar, public router: Router) {
        this.busy = true;
        this.getVersions();
    }

    getVersions() {
        this.softwareService.getAllVersions().subscribe(result => {
            this.versions = result.json();
            this.busy = false;
        }, err => {
            this.busy = false;
            this.versions = [];
            this.snackBar.open('Error loading versions', null, { duration: 3000 });
        });
    }
}



// WEBPACK FOOTER //
// ./Client/app/containers/versions/versions.component.ts